export { default } from './EntityFieldSlotSpacer';
